import React, { useEffect } from 'react'
import { Grid, Heading, useToast } from '@chakra-ui/react'
import CollectingScoresStatistics from './CollectingScoresStatistics'
import CollectingScoresFilters from './CollectingScoresFilters'
import CollectingScoresTable from './CollectingScoresTable'
import { useScoreStore } from '../../store/scoreStore'
import { useFetching } from '../../hooks/useFetching'
import ScoreService from '../../API/ScoreService'
import { useStudentsStore } from '../../store/studentsStore'
import UmSpinner from '../../components/UI/UmSpinner'
import { toastError } from '../../utils/globalHelper'

function CollectingScores() {
    const toast = useToast()
    const fetchCommunicationTypes = useStudentsStore(state => state.fetchCommunicationTypes)
    const scores = useScoreStore(state => state.scores)
    const setScores = useScoreStore(state => state.setScores)
    const fetchScoresTags = useScoreStore(state => state.fetchTags)
    const setFiltersFromData = useScoreStore(state => state.setFiltersFromData)
    const [fetchScores, isLoading, fetchError] = useFetching(async () => {
        const response = await ScoreService.getStudentsScores()
        if (response?.status === 200) {
            setScores(response.data)
            setFiltersFromData(response.data.data)
        }
    })

    useEffect(() => {
        fetchCommunicationTypes()
        fetchScoresTags()
    }, [])

    useEffect(() => {
        fetchScores()
    }, [])

    useEffect(() => {
        if (fetchError)
            toast(toastError('Ошибка загрузки данных'))
    }, [fetchError])

    if (isLoading)
        return <UmSpinner />

    if (Object.keys(scores).length < 1)
        return <Heading size='xl'>Нет данных</Heading>

    return (
        <Grid gap='var(--default-gap)'>
            <CollectingScoresStatistics />
            <CollectingScoresFilters />
            <CollectingScoresTable />
        </Grid>
    )
}

export default CollectingScores
